import { ModuleWithProviders, NgModule } from "@angular/core";
import { HankoService } from "./hanko.service";
import { register } from "@teamhanko/hanko-elements";
import { de } from "@teamhanko/hanko-elements/i18n/de";
import { en } from "@teamhanko/hanko-elements/i18n/en";
import { HANKO_AUTH_API_URL, HANKO_OPTIONS, HANKO_URL } from "./inj-token";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { HankoAuthInterceptor } from "./interceptor";
import { SopiHankoOptions } from "./model";

@NgModule({
    providers: [HankoService]
})
export class HankoModule {

    public static forRoot(opt: SopiHankoOptions
    ): ModuleWithProviders<HankoModule> {

        // hanko  elements registrieren
        register(opt.hankoUrl, {
            translations: { de, en },
            shadow: true,
            injectStyles: true,
        }).catch((error) => {
            console.error(error);
        });


        return {
            ngModule: HankoModule,
            providers: [
                {
                    provide: HANKO_URL,
                    useValue: opt.hankoUrl,
                },
                {
                    provide: HANKO_AUTH_API_URL,
                    useValue: opt.apiUrl,
                },
                {
                    provide: HANKO_OPTIONS,
                    useValue: opt,
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: HankoAuthInterceptor,
                    multi: true
                },
            ]
        }

    }


}